const isVisible = (e) => {
    return e && !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
};

export default isVisible;
